module.exports = __webpack_public_path__ + "static/flux-ia-homenav-ba3b216354addcce33e8c4d3cb6a8b29.jpg";